export default __webpack_public_path__ + "static/media/Anishaa Choudhury.e87b2d5e.jpg";